// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/bento-carousel.js'; import './autoload/foundation.js'; import './autoload/image-with-repeat-data.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/* global ajax_object */

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

//inialize .two-cards-list-slider slick slider on <768 and destroy it on >768
const checkMobileSlider = (sliderClass) => {
  $('.' + sliderClass).each(function () {
    let $this = $(this);
    //check if slick slider is initialized
    if ($this.hasClass('slick-initialized') && window.innerWidth > 767) {
      $this.slick('unslick');
    } else {
      if (!$this.hasClass('slick-initialized') && window.innerWidth < 768) {
        let dotsContainer = $this.parent().find('.dots-container');
        $this.slick({
          infinite: false,
          cssEase: 'linear',
          slidesToShow: 2.5,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 1000,
          arrows: true,
          dots: false,
          appendArrows: dotsContainer,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1.8,
                variableWidth: false,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.2,
                variableWidth: false,
              },
            },
          ],
        });
      }
    }
  });
};

/**
 * Pricing block functional
 */
class Pricing {
  constructor() {
    this.bindEvents();
    this.$checkoutButton = $('.summary-list a.button');
  }

  bindEvents() {
    // switch price period
    $('.pricing-toggle input[type="radio"]').on('change', (e) =>
      this.switchPeriod(e)
    );

    // select plan
    $('.list-item__content a.plus-button').on('click', (e) =>
      this.selectPlan(e)
    );

    // resource buttons
    $('.resources-item__middle button').on('click', (e) =>
      this.updateResource(e)
    );
  }

  switchPeriod(e) {
    const $input = $(e.currentTarget);

    $('.change-value').each(function () {
      let $el = $(this);
      if ($input.val() === '1') {
        $el.text($el.data('year'));
        $('.price-discount').show();
      } else {
        $el.text($el.data('month'));
        $('.price-discount').hide();
      }
    });

    this.updateResourcesPrice();
    this.updateTotalPrice();
  }

  selectPlan(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const $parent = $btn.closest('.list-item__content');

    $('.selected-plan').text($parent.find('.name').text());

    const $planPrice = $parent.find('.plan-price');
    if ($planPrice.hasClass('selected')) return;

    $('.plan-price.selected').removeClass('selected');
    $('.list-item__content.selected').removeClass('selected');
    $planPrice.addClass('selected');
    $parent.addClass('selected');

    const resourcesListEl = $('.resources-list');

    if (resourcesListEl) {
      resourcesListEl.addClass('slide-up');

      const headerHeight = $('#header').outerHeight() || 0;
      let step2ElHeight = $('.pricing-element--step2').offset().top;
      let targetTop = step2ElHeight - headerHeight;

      $('html, body').animate({ scrollTop: targetTop }, 500);
    }

    this.updateTotalPrice();
  }

  updateResource(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const $input = $btn.siblings('input[type="number"]');
    let value = parseInt($input.val(), 10) || 0;

    if ($btn.hasClass('plus')) {
      $input.val(value + 1);
      $btn.siblings('.minus').removeClass('disabled');
    } else if ($btn.hasClass('minus')) {
      if (value > 0) $input.val(value - 1);
      if (value <= 1) $btn.addClass('disabled');
    }

    this.updateResourcesPrice();
    this.updateSelectedResources();
    this.updateTotalPrice();
  }

  updateResourcesPrice() {
    $('.resources-item__input').each(function () {
      const $input = $(this);
      const $parent = $input.closest('.resources-item');
      const price = parseFloat($parent.find('.resource-price').text());
      const total = price * ($input.val() || 0);
      $parent.find('.resource-item-total').text(total.toFixed(2));
    });
  }

  updateSelectedResources() {
    let names = [];
    $('.resources-item__input').each(function () {
      const $input = $(this);
      if ($input.val() > 0) {
        const name = $input
          .closest('.resources-item')
          .find('.resource-name')
          .text();
        names.push(`${$input.val()} ${name}`);
      }
    });
    $('.selected-resources').text(names.join(', '));
  }

  // Main calculate method
  updateTotalPrice() {
    const total = this.calculateTotal();
    this.updateTotalPriceDisplay(total);
    this.updateCheckoutButton(total);
  }

  // Calculate total sum (plan + resources)
  calculateTotal() {
    let total = 0;

    // Sum selected plan(s)
    total += $('.plan-price.selected')
      .toArray()
      .reduce((sum, el) => {
        const price = parseFloat($(el).text()) || 0;
        return sum + price;
      }, 0);

    // Sum resources
    total += $('.resource-item-total')
      .toArray()
      .reduce((sum, el) => {
        const price = parseFloat($(el).text()) || 0;
        return sum + price;
      }, 0);

    return total;
  }

  // Update total price on the page
  updateTotalPriceDisplay(total) {
    $('.total-price').text(total.toFixed(2));
  }

  // Build checkout URL and update button
  updateCheckoutButton() {
    let checkoutUrl = this.$checkoutButton.data('attr');

    // Add selected billing cycle
    const selectedPeriod = $(
      '.pricing-toggle input[type="radio"]:checked'
    ).data('billingcycle');
    checkoutUrl += `&billingcycle=${selectedPeriod}`;

    // Add selected plan(s)
    $('.plan-price.selected').each(function () {
      const productId = $(this).data('product');
      checkoutUrl += `&pid=${productId}`;
    });

    // Add selected resources
    $('.resources-item__input').each(function () {
      const $input = $(this);
      if ($input.val() > 0) {
        const productId = $input.data('product');
        checkoutUrl += `&configoption[${productId}]=${$input.val()}`;
      }
    });

    // Update checkout button link
    this.$checkoutButton.attr('href', checkoutUrl);
  }
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  $(document).on('click', '.load-posts', function (e) {
    e.preventDefault();

    const $btn = $(this);
    if ($btn.hasClass('active') || $btn.data('requestRunning')) return;

    const data = {
      action: 'load_posts',
      nonce: ajax_object.nonce,
      offset: $btn.parents('.relates-posts').find('.post-item').length,
      not_in: $btn.data('current') || '',
      cat: $btn.data('cat') || '',
      sort: $btn.data('sort') || '',
    };
    $btn.data('requestRunning', true).addClass('loading');
    $('.posts-grid').addClass('loading');

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: data,
      success: function (response) {
        $('.posts-grid').append(response);
        //check if there are more posts to load
        if ($('.post-item').length >= ajax_object.total_posts) {
          $btn.addClass('active').hide();
        } else {
          $btn.removeClass('loading');
        }
      },
      error: function (err) {
        console.error(err);
        $btn.removeClass('loading').data('requestRunning', false);
      },
      complete: function () {
        $btn.removeClass('loading').data('requestRunning', false);
        $('.posts-grid').removeClass('loading');
      },
    });
  });

  //if any select inside .blog-filters__left form change then submit form
  $('.blog-filters__left select').on('change', function () {
    $(this).closest('form').submit();
  });

  /**
   * Sliders
   */
  $('.logos-slider').each(function () {
    let $slider = $(this),
      $slideToShow = $slider.data('slides-to-show') || 1;

    $slider.slick({
      infinite: true,
      cssEase: 'linear',
      slidesToShow: $slideToShow,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: false,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 468,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
          },
        },
      ],
    });
  });

  if ($('.testimonial-slider').length) {
    var $testimonialSlider = $('.testimonial-slider');
    $testimonialSlider.on('mouseenter', function () {
      $(this)
        .find('.testimonial-slider__row-item')
        .css('animation-play-state', 'paused');
    });

    $testimonialSlider.on('mouseleave', function () {
      $(this)
        .find('.testimonial-slider__row-item')
        .css('animation-play-state', 'running');
    });
  }

  $('.cards-list-slider').each(function () {
    let $slider = $(this),
      dotsContainer = $('.text-carousel__content').find('.dots-container');

    function initSlick(infiniteMode) {
      $slider.slick({
        infinite: infiniteMode,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1000,
        arrows: true,
        dots: false,
        variableWidth: true,
        appendArrows: dotsContainer,
      });
    }

    // запускаємо без infinite
    initSlick(false);

    // перевірка слайду
    $slider.on('afterChange', function (event, slick, currentSlide) {
      if (currentSlide === 1 && !slick.options.infinite) {
        // видаляємо slick
        $slider.slick('unslick');
        // ініціалізуємо заново з infinite
        initSlick(true);
        // одразу виставляємо той самий слайд
        $slider.slick('slickGoTo', currentSlide, true);
      }
    });
  });

  checkMobileSlider('two-cards-list-slider');
  checkMobileSlider('text-carousel-alt__slider');

  checkMobileSlider('text-cards-mobile-slider-list');

  /**
   *Initialize pricing module
   */
  new Pricing();

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  // const header = document.getElementById('header');
  //
  // let lastScrollTop = 0;
  // // eslint-disable-next-line no-unused-vars
  // let hasScrolledPast = false;
  //
  // window.addEventListener('scroll', () => {
  //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
  //
  //   if (scrollTop > 50) {
  //     header.classList.add('header-floating');
  //   } else {
  //     header.classList.remove('header-floating');
  //   }
  //
  //   if (scrollTop > 500) {
  //     hasScrolledPast = true;
  //
  //     if (scrollTop > lastScrollTop) {
  //       header.classList.add('header-leave');
  //     } else {
  //       header.classList.remove('header-leave');
  //     }
  //   } else {
  //     header.classList.remove('header-leave');
  //     hasScrolledPast = false;
  //   }
  //
  //   lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  // });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  checkMobileSlider('two-cards-list-slider');
  checkMobileSlider('text-carousel-alt__slider');

  checkMobileSlider('text-cards-mobile-slider-list');
  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
const $window = $(window);
const $header = $('.header');
let lastScrollTop = 0;

$window.on('scroll', function () {
  const y = $window.scrollTop();
  const direction = y > lastScrollTop ? 'down' : 'up';
  lastScrollTop = y;

  if (
    y > 500 &&
    direction === 'down' &&
    !$('.mega-menu-item').hasClass('mega-toggle-on')
  ) {
    $header.addClass('header-leave');
  } else if (direction === 'up') {
    $header.removeClass('header-leave');
  }
});

/**
 * Scripts that run for the popup
 */
$(window).on('load', function () {
  const popup = document.getElementById('popup');

  document.getElementById('openPopup').addEventListener('click', (e) => {
    e.preventDefault();
    popup.classList.add('active');
    document.body.classList.add('popup-open');
  });

  document.getElementById('closePopup').addEventListener('click', () => {
    popup.classList.remove('active');
    document.body.classList.remove('popup-open');
  });

  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.classList.remove('active');
      document.body.classList.remove('popup-open');
    }
  });

  window.addEventListener('message', function (event) {
    if (event.data.type === 'close-popup-from-iframe') {
      popup.classList.remove('active');
    }
  });
});
